import { useEffect, useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom';
import MarkdownIt from 'markdown-it'
import hljs from 'highlight.js'
import mila from 'markdown-it-link-attributes'
import mdKatex from '@traptitech/markdown-it-katex'
import { Tooltip, Popover } from 'antd'
import { format, parseISO, addHours } from 'date-fns';

import styles from './index.module.css'
import { actionCreators } from '../../store'
import { actionCreators as homeActionCreators } from '../../../home/store'
import { generateOptionsByChatData, chatTypeIcons, } from '../../../../utils'
import CollectItemInput from '../CollectItemInput'
import ModalImageView from '../../../../common/ModalImageView'

import openVector from '../../../../statics/collect_open_vector.png'
import closeVector from '../../../../statics/collect_close_vector.png'
import dragVector from '../../../../statics/collect_drag_vector.png'
import messageVector from '../../../../statics/collect_message_vector.png'
import conversationImg from '../../../../statics/collect_text_conversation.png'
import writeImg from '../../../../statics/collect_text_write.png'
import markImg from '../../../../statics/collect_popover_mark.png'
import editImg from '../../../../statics/collect_popover_edit.png'


const CustomPopover = (props) => {
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    let conversation = props.conversation

    const popoverOpenChange = (open) => {
        setOpen(open)
    };

    const hidePopover = () => {
        setOpen(false)
    }

    const handleItemCancelMark = () => {
        hidePopover()
        dispatch(actionCreators.postCollectionCreate(true, 'conversation', conversation.conversation_id))
    }

    const handleItemRename = () => {
        hidePopover()
        dispatch(actionCreators.conversationRenameAction(conversation.conversation_id))
    }

    let content = (
        <div className={styles.popover_box}>
            <div
                className={styles.popover_item}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleItemRename() }}
            >
                <img src={editImg} className={styles.popover_butn_img} />
                <span className={styles.popover_item_text}>重命名</span>
            </div>

            <div
                className={styles.popover_item}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleItemCancelMark()}}
            >
                <img src={markImg} className={styles.popover_butn_img} />
                <span className={styles.popover_item_text}>移除星标</span>
            </div>
        </div>
    )

    return (
        <Popover
            overlayClassName='custom_popover_collect'
            content={content}
            placement="right"
            trigger="click"
            open={open}
            onOpenChange={(e) => {popoverOpenChange(e)}}
        >
            <Tooltip placement="top" title={"更多"}>
                <div className={styles.tool_more}></div>
            </Tooltip>
        </Popover>
    )
}

const ListItem = (props) => {
    const history = useHistory();
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const [isHovering, setIsHovering] = useState(false)
    let conversation = props.conversation

    const handleEnterConversation = () => {
        dispatch(homeActionCreators.isShowScreenPersonalOverview(false))
        dispatch(homeActionCreators.isShowScreenStoneModelMall(false))
        dispatch(homeActionCreators.isShowScreenPersonalBackpack(false))
        dispatch(homeActionCreators.activeTopicIdAction(props.ChatDataDate, conversation.conversation_id))

        history.push('/home')
    }

    const handleDeleteConversation = () => {
        dispatch(actionCreators.deleteConversationAction(conversation.conversation_id))
    }

    const convertToBeijingTime = (backendDate) => {
        // 将ISO格式的时间字符串解析为日期对象
        const parsedDate = parseISO(backendDate);

        // 将时间增加8小时，转换为东八区时间
        const beijingDate = addHours(parsedDate, 8);

        return beijingDate;
    }

    const formatCreatedTime = (backendDate) => {
        try {
            const beijingDate = convertToBeijingTime(backendDate);

            if (props.ChatDataDate === 'today') {
                const time24Hour = format(beijingDate, 'HH:mm');
                const amPm = format(beijingDate, 'a').toUpperCase();
                return `${time24Hour} ${amPm}`;
            } else {
                return format(beijingDate, 'dd MMM yyyy')
            }
        } catch {
            return '------'
        }
    }

    return (
        <div
            className={`${styles.list_item} ${open ? styles.list_item_open : ''}`}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            <div className={styles.item_top}>
                <div className={styles.vector_box}>
                    {/* <img src={dragVector} className={styles.vector_drag} /> */}
                    <img src={messageVector} className={styles.vector_message} />
                </div>

                <div className={styles.abstract_box}>
                    {
                        conversation.is_edit_name ? (
                            <CollectItemInput
                                CurrentConversationId={conversation.conversation_id}
                                ConversationNameEdit={conversation.conversation_name_edit}
                            />
                        ) : (
                            <div className={styles.abstract}>
                                { conversation.conversation_name }
                            </div>
                        )
                    }
                </div>

                <div className={styles.tool_box}>
                    {
                        isHovering ? (
                            <>
                                <Tooltip placement="top" title={"进入对话"}>
                                    <div
                                        className={styles.tool_enter}
                                        onClick={handleEnterConversation}
                                    >
                                    </div>
                                </Tooltip>
                                <Tooltip placement="top" title={"删除对话"}>
                                    <div
                                        className={styles.tool_delete}
                                        onClick={handleDeleteConversation}
                                    >
                                    </div>
                                </Tooltip>
                                <CustomPopover
                                    conversation={props.conversation}
                                    ChatDataDate={props.ChatDataDate}
                                    handleItemRename={props.handleItemRename}
                                />
                            </>
                        ) : (
                            <div className={styles.time}>{ `创建于 ${formatCreatedTime(conversation.created_at)}` }</div>
                        )
                    }
                </div>

                <div className={styles.vector_open_box} onClick={() => setOpen(!open)}>
                    {
                        open ? (
                            <img src={openVector} className={styles.vector_open} />
                        ) : (
                            <img src={closeVector} className={styles.vector_open} />
                        )
                    }
                </div>
            </div>

            <div className={styles.item_bottom}>
                <div className={styles.model_box}>
                    {/* <img src={obj?.avatar} className={styles.model_img} />
                    <div className={styles.model_name}>
                        { obj?.label }
                    </div> */}
                    <img src={chatTypeIcons['agent_chat']} className={styles.model_img} />
                    <div className={styles.model_name}>
                        { "我的灵石" }
                    </div>
                </div>

                <div className={styles.num_box}>
                    {/* <div className={styles.text_box}>
                        <div className={styles.text_title}>总共对话</div>
                        <img src={conversationImg} className={styles.text_img} />
                        <div className={styles.num}>{ conversation.data.length }</div>
                    </div> */}

                    <div className={styles.text_box}>
                        <div className={styles.text_title}>AI修改</div>
                        <img src={writeImg} className={styles.text_img} />
                        <div className={styles.num}>0</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const AskListItem = (props) => {
    const history = useHistory();
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const [isHovering, setIsHovering] = useState(false)
    const [isImageModalOpen, setIsImageModalOpen] = useState(false)
    const [showImageUrl, setShowImageUrl] = useState('')
    let conversation = props.conversation

    const handleCancelMark = (resource_id) => {
        dispatch(actionCreators.postCollectionCreate(true, 'message', resource_id))
    }

    const handleEnterConversation = () => {
        dispatch(homeActionCreators.isShowScreenPersonalOverview(false))
        dispatch(homeActionCreators.isShowScreenStoneModelMall(false))
        dispatch(homeActionCreators.isShowScreenPersonalBackpack(false))
        dispatch(homeActionCreators.activeTopicIdAction(props.ChatDataDate, conversation.conversation_id))

        history.push('/home')
    }

    const convertToBeijingTime = (backendDate) => {
        // 将ISO格式的时间字符串解析为日期对象
        const parsedDate = parseISO(backendDate);

        // 将时间增加8小时，转换为东八区时间
        const beijingDate = addHours(parsedDate, 8);

        return beijingDate;
    }

    const formatCreatedTime = (backendDate) => {
        try {
            const beijingDate = convertToBeijingTime(backendDate);

            if (props.ChatDataDate === 'today') {
                const time24Hour = format(beijingDate, 'HH:mm');
                const amPm = format(beijingDate, 'a').toUpperCase();
                return `${time24Hour} ${amPm}`;
            } else {
                return format(beijingDate, 'dd MMM yyyy')
            }
        } catch {
            return '------'
        }
    }

    const renderMdHtml = (value) => {
        function highlightBlock (str, lang, code) {
            return `<pre class="code-block-wrapper"><div class="code-block-header"><span class="code-block-header__lang">${lang}</span><span class="code-block-header__copy">复制代码</span></div><code class="hljs code-block-body ${lang}">${str}</code></pre>`
        }

        const mdi = new MarkdownIt({
            html: true,
            linkify: false,     // 禁用自动链接插件
            highlight (code, language) {
                const validLang = !!(language && hljs.getLanguage(language))
                if (validLang) {
                    const lang = language ?? ''
                    return highlightBlock(hljs.highlight(code, { language: lang }).value, lang, code)
                }
                return highlightBlock(hljs.highlightAuto(code).value, '', code)
            }
        })

        mdi.use(mila, { attrs: { target: '_blank', rel: 'noopener' } })
        mdi.use(mdKatex, { blockClass: 'katex-block', errorColor: ' #cc0000', output: 'mathml' })

        return mdi.render(value)
    }

    const renderText = (value) => {
        value = value ? value : ''
        let render_md_html = renderMdHtml(value)
        return (
            <div
                className="markdown-body"
                dangerouslySetInnerHTML={{
                    __html: render_md_html
                }}
            >
            </div>
        )
    }

    const handleContentClick = (e) => {
        if (e.target.closest(".msg_images_id_like")) {
            let div = e.target.closest(".msg_images_id_like");
            let data_id = div.dataset.id; // dataset 中的 'id' 对应于 'data-id' 属性
            let data_message_id = div.dataset.message_id;
            let data_url = div.dataset.url;
            let data_score = div.dataset.score;
            let data_index_msg = div.dataset.index_msg;

            // 检查 score 是否为合法的整数
            if ( data_score && !isNaN(data_score) && Number.isInteger(Number(data_score)) ) {
                // 转换为整数
                data_score = parseInt(data_score, 10);
                if (data_score <= 0) {
                    data_score = 1;
                } else {
                    data_score = -1;
                }
            } else {
                data_score = 1;
            }

            console.log(`data_id = (${data_id})`);
            console.log(`data_message_id = (${data_message_id})`);
            console.log(`data_url = (${data_url})`);
            console.log(`data_score = (${data_score})`);

            // this.props.handleMessageImageScoreLikeAction(div, data_id, data_url, data_score, data_message_id, data_index_msg)
        } else if (e.target.closest('.msg_images_id_overlay')) {
            console.log("msg_images_id_overlay");
            // 访问 div 元素的 data-url 属性
            let div = e.target.closest('.msg_images_id_overlay')
            const imageUrl = div.dataset.url; // dataset 中的 'url' 对应于 'data-url' 属性
            const doc_id = div.dataset.doc_id;
            setShowImageUrl(imageUrl)
            setIsImageModalOpen(true)
            if (doc_id) {
                dispatch(actionCreators.getMessagePictureClick(doc_id))
            }
        } else if (e.target.closest('.msg_images_id')) {
            console.log("msg_images_id");
            let div = e.target.closest('.msg_images_id')
            const imageUrl = div.dataset.url; // dataset 中的 'url' 对应于 'data-url' 属性
            setShowImageUrl(imageUrl)
            setIsImageModalOpen(true)
        } else if (e.target.closest('.msg_search_result_title') || e.target.closest('.msg_search_result_title_icon')) {
            let div;
            if (e.target.closest('.msg_search_result_title')) {
                div = e.target.closest('.msg_search_result_title');
            } else if (e.target.closest('.msg_search_result_title_icon')) {
                div = e.target.closest('.msg_search_result_title_icon');
            }

            if (div) {
                // 找到爷爷元素
                let grandparent = div.parentNode.parentNode;

                // 检查是否存在特定的class
                if (grandparent.classList.contains("msg_search_result_container_shrink")) {
                    // 如果存在
                    grandparent.classList.remove("msg_search_result_container_shrink");
                } else {
                    // 如果不存在
                    grandparent.classList.add("msg_search_result_container_shrink");
                }
            }
        } else if (e.target.closest('.material_mode_item_image')) {
            let div = e.target.closest(".material_mode_item_image");
            let data_url = div.dataset.url;
            setShowImageUrl(data_url)
            setIsImageModalOpen(true)
        }
    }

    return (
        <div
            className={styles.ask_list_item}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            onClick={handleContentClick}
        >
            <div className={`${styles.ask_item_top} ${open ? styles.ask_item_top_open : null}`}>
                <div className={styles.ask_vector_box}>
                    {/* <img src={dragVector} className={styles.vector_drag} /> */}
                    {/* <img src={messageVector} className={styles.vector_message} /> */}
                    <img src={chatTypeIcons['agent_chat']} className={styles.ask_model_img} />
                </div>

                {/* <div className={styles.ask_abstract_box}>
                    <div className={styles.ask_abstract}>
                        { conversation.text }
                    </div>
                </div> */}
                <div className={`${styles.ask_abstract} ${open ? styles.expanded : styles.collapsed}`}>
                    {open ? (
                        // 展开状态下显示完整内容
                        <>
                            { renderText(conversation.text + conversation.text_extra_img + conversation.text_extra_search) }
                        </>
                    ) : (
                        // 收缩状态下仅显示前两行
                        <>
                            { renderText(conversation.text + conversation.text_extra_img + conversation.text_extra_search) }
                        </>
                    )}
                </div>

                <div className={styles.ask_tool_box}>
                    {
                        isHovering ? (
                            <>
                                <Tooltip placement="top" title={"取消收藏"}>
                                    <div
                                        className={styles.tool_collect}
                                        onClick={() => {handleCancelMark(conversation.message_id)}}
                                    >
                                    </div>
                                </Tooltip>
                                <Tooltip placement="top" title={"进入对话"}>
                                    <div
                                        className={styles.tool_enter}
                                        onClick={handleEnterConversation}
                                    >
                                    </div>
                                </Tooltip>
                            </>
                        ) : (
                            <div className={styles.time}>{ `创建于 ${formatCreatedTime(conversation.query_at)}` }</div>
                        )
                    }
                </div>

                <div className={styles.ask_vector_open_box} onClick={() => setOpen(!open)}>
                    {
                        open ? (
                            <img src={openVector} className={styles.vector_open} />
                        ) : (
                            <img src={closeVector} className={styles.vector_open} />
                        )
                    }
                </div>
            </div>

            <ModalImageView
                isModalOpen={isImageModalOpen}
                setIsModalOpen={setIsImageModalOpen}
                showImageUrl={showImageUrl}
                setShowImageUrl={setShowImageUrl}
            />
        </div>
    )
}

const ShowBox = () => {
    const dispatch = useDispatch()
    let datetime_category_list_immutable = useSelector(state => state.get('collect').get('datetime_category_list'))
    let content_category_list_immutable = useSelector(state => state.get('collect').get('content_category_list'))
    let collection_conversation_list_immutable = useSelector(state => state.get('collect').get('collection_conversation_list'))
    let collection_message_list_immutable = useSelector(state => state.get('collect').get('collection_message_list'))
    const [currentList, setCurrentList] = useState([])
    console.log("currentList = ", currentList);

    useEffect(() => {
        let datetime_category_list = datetime_category_list_immutable.toJS()
        let temp_datetime = datetime_category_list.find(item => item.active === true)?.label || '所有'
        let content_category_list = content_category_list_immutable.toJS()
        let temp_content_category = content_category_list.find(item => item.active === true)?.value || 'conversation'
        console.log("temp_content_category = ", temp_content_category);

        if (temp_content_category === 'conversation') {
            let l = filterDataByTimeRange(collection_conversation_list_immutable.toJS(), temp_datetime, 'created_at')
            setCurrentList(l)
        } else {
            // temp_content_category === 'ask'
            let l = filterDataByTimeRange(collection_message_list_immutable.toJS(), temp_datetime, 'query_at')
            setCurrentList(l)
        }
    }, [datetime_category_list_immutable, content_category_list_immutable, collection_conversation_list_immutable, collection_message_list_immutable])

    let current_content_category = useMemo(() => {
        let content_category_list = content_category_list_immutable.toJS()
        return content_category_list.find(item => item.active === true)?.value || 'conversation'
    }, [datetime_category_list_immutable, content_category_list_immutable, collection_conversation_list_immutable, collection_message_list_immutable])

    function filterDataByTimeRange(data, timeRange, time_key) {
        const now = new Date();  // 获取当前本地时间
        const startOfToday = new Date(now.setHours(0, 0, 0, 0)); // 今天的开始时间（00:00:00）
        let result = [];

        // 时间范围处理
        const timeRanges = ['今天', '过去3天', '过去7天', '过去30天'];
        const timeValueRanges = ['today', 'third_day', 'seventh_day', 'thirtieth_day'];

        // 根据选中的 timeRange 进行分类
        if (timeRange === '所有') {
            // 如果是选择所有时间范围，返回包含所有时间段的数据
            result = timeRanges.map((range, index) => {
                let filterDateStart, filterDateEnd;

                switch (range) {
                    case '今天':
                        filterDateStart = startOfToday;
                        filterDateEnd = new Date(startOfToday.getTime() + 24 * 60 * 60 * 1000); // 今天的结束时间（明天零点）
                        break;
                    case '过去3天':
                        filterDateStart = new Date(now);
                        filterDateStart.setDate(now.getDate() - 3);
                        filterDateStart.setHours(0, 0, 0, 0);  // 设置为00:00:00
                        filterDateEnd = new Date(now);
                        filterDateEnd.setDate(now.getDate() - 1);
                        filterDateEnd.setHours(23, 59, 59, 999);  // 设置为23:59:59
                        break;
                    case '过去7天':
                        filterDateStart = new Date(now);
                        filterDateStart.setDate(now.getDate() - 7);
                        filterDateStart.setHours(0, 0, 0, 0);
                        filterDateEnd = new Date(now);
                        filterDateEnd.setDate(now.getDate() - 4);
                        filterDateEnd.setHours(23, 59, 59, 999);
                        break;
                    case '过去30天':
                        filterDateStart = new Date(now);
                        filterDateStart.setDate(now.getDate() - 30);
                        filterDateStart.setHours(0, 0, 0, 0);
                        filterDateEnd = new Date(now);
                        filterDateEnd.setDate(now.getDate() - 8);
                        filterDateEnd.setHours(23, 59, 59, 999);
                        break;
                    default:
                        return [];
                }

                // 将本地时间范围转换为 UTC 时间
                const filterDateStartUTC = new Date(filterDateStart.toUTCString());
                const filterDateEndUTC = new Date(filterDateEnd.toUTCString());

                const filteredData = data.filter(item => {
                    const createdAt = new Date(item[time_key]);  // 这里假设后台返回的 `created_at` 已经是 UTC 时间
                    return createdAt >= filterDateStartUTC && createdAt <= filterDateEndUTC;
                });

                return {
                    value: range,
                    data_date: timeValueRanges[index],
                    data: filteredData,
                };
            });

            return result
        } else {
            // 仅根据选定的 timeRange 筛选数据
            let filterDateStart, filterDateEnd;
            switch (timeRange) {
                case '今天':
                    filterDateStart = startOfToday;
                    filterDateEnd = new Date(startOfToday.getTime() + 24 * 60 * 60 * 1000); // 今天的结束时间（明天零点）
                    break;
                case '过去3天':
                    filterDateStart = new Date(now);
                    filterDateStart.setDate(now.getDate() - 3);
                    filterDateStart.setHours(0, 0, 0, 0);
                    filterDateEnd = new Date(now);
                    filterDateEnd.setDate(now.getDate() - 1);
                    filterDateEnd.setHours(23, 59, 59, 999);
                    break;
                case '过去7天':
                    filterDateStart = new Date(now);
                    filterDateStart.setDate(now.getDate() - 7);
                    filterDateStart.setHours(0, 0, 0, 0);
                    filterDateEnd = new Date(now);
                    filterDateEnd.setDate(now.getDate() - 4);
                    filterDateEnd.setHours(23, 59, 59, 999);
                    break;
                case '过去30天':
                    filterDateStart = new Date(now);
                    filterDateStart.setDate(now.getDate() - 30);
                    filterDateStart.setHours(0, 0, 0, 0);
                    filterDateEnd = new Date(now);
                    filterDateEnd.setDate(now.getDate() - 8);
                    filterDateEnd.setHours(23, 59, 59, 999);
                    break;
                default:
                    return data;  // 如果不在预设的范围内，直接返回原数据
            }

            // 将本地时间范围转换为 UTC 时间
            const filterDateStartUTC = new Date(filterDateStart.toUTCString());
            const filterDateEndUTC = new Date(filterDateEnd.toUTCString());

            result = data.filter(item => {
                console.log("item[time_key] = ", item[time_key]);
                const createdAt = new Date(item[time_key]);  // 假设 `created_at` 已经是 UTC 时间
                return createdAt >= filterDateStartUTC && createdAt <= filterDateEndUTC;
            });

            return [{
                value: timeRange,
                data_date: timeValueRanges[timeRanges.indexOf(timeRange)],
                data: result,
            }];
        }
    }

    let count_item = 0

    return (
        <div className={styles.container}>
            <div className={styles.main}>
                {
                    currentList.map((item, index) => {
                        if (item.data.length !== 0) {
                            count_item += 1;

                            return (
                                <div className={styles.filter_box} key={item.value}>
                                    <div className={styles.filter_title}>{item.value}</div>
                                    {
                                        count_item === 1 ? (
                                            <div className={styles.filter_hint}>请点击对话进入修改</div>
                                        ) : null
                                    }
                                    <div className={styles.list_box}>
                                        {
                                            item.data.map((child_item) => {
                                                return (
                                                    <div
                                                        key={child_item.id}
                                                        className={styles.list_item_box}
                                                    >
                                                        {
                                                            current_content_category === 'conversation' ? (
                                                                <ListItem
                                                                    conversation={child_item}
                                                                    ChatDataDate={item.data_date}
                                                                />
                                                            ) : (
                                                                <AskListItem
                                                                    conversation={child_item}
                                                                    ChatDataDate={item.data_date}
                                                                />
                                                            )
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        } else {
                            return null
                        }
                    })
                }
            </div>
        </div>
    )

    // return (
    //     <div className={styles.container}>
    //         <div className={styles.main}>
    //             {
    //                 currentList.map((item, index) => {
    //                     if (item.data.length !== 0) {
    //                         count_item += 1;

    //                         return (
    //                             <div className={styles.filter_box} key={item.value}>
    //                                 <div className={styles.filter_title}>{item.value}</div>
    //                                 {
    //                                     count_item === 1 ? (
    //                                         <div className={styles.filter_hint}>请点击对话进入修改</div>
    //                                     ) : null
    //                                 }
    //                                 <div className={styles.list_box}>
    //                                     {
    //                                         item.data.map((child_item) => {
    //                                             return (
    //                                                 <div
    //                                                     key={child_item.conversation_id}
    //                                                     className={styles.list_item_box}
    //                                                 >
    //                                                     <ListItem
    //                                                         conversation={child_item}
    //                                                         ChatDataDate={item.data_date}
    //                                                     />
    //                                                 </div>
    //                                             )
    //                                         })
    //                                     }
    //                                 </div>
    //                             </div>
    //                         )
    //                     } else {
    //                         return null
    //                     }
    //                 })
    //             }
    //         </div>
    //     </div>
    // )
}

export default ShowBox